import { Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { NOTICE_TYPES, OPERATION_TYPES } from '../common/constants';
import NoticeTypeIcon from './common/NoticeTypeIcons';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const OperationLogDialog = (props) => {
  const { typography } = useTheme();
  const operationLog = props.operationLog;

  const handleClose = () => {
    props.setOpen(false);
  };

  const noticeTypeLabel = (noticeTypeCode) => {
    switch (noticeTypeCode) {
      case NOTICE_TYPES.THIRTY_FIVE_LIMIT.value:
        return NOTICE_TYPES.THIRTY_FIVE_LIMIT.label;
      case NOTICE_TYPES.TWENTY_FIVE_LIMIT.value:
        return NOTICE_TYPES.TWENTY_FIVE_LIMIT.label;
      case NOTICE_TYPES.SUSPENSION.value:
        return NOTICE_TYPES.SUSPENSION.label;
      case NOTICE_TYPES.LIMIT_CANCEL.value:
        return NOTICE_TYPES.LIMIT_CANCEL.label;
      case NOTICE_TYPES.SUSPENSION_CANCEL.value:
        return NOTICE_TYPES.SUSPENSION_CANCEL.label;
      case NOTICE_TYPES.SLOWDOWN.value:
        return NOTICE_TYPES.SLOWDOWN.label;
    };
  };

  const operationLogStyle = (operationName) => {
    if (operationName === OPERATION_TYPES.RECEIVE_NOTICE.label) {
      return {
        padding: '16px 32px',
        marginBottom: '8px',
        border: 1,
        borderColor: 'primary.main',
      };
    } else {
      return {
        padding: '16px 32px',
        marginBottom: '8px',
      };
    }
  };

  if (operationLog) {
    return (
      <Dialog
        open={props.open}
        onClose={handleClose}
        fullWidth
        PaperProps={{
          sx: {
            minWidth: '560px',
            height: '576px',
          },
        }}
      >
        <DialogTitle variant='body16bold' textAlign='center' position='relative'>
          操作ログ
          <IconButton
            sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: '24px 96px' }}>
          {operationLog.map((log, counter) => (
            <Stack key={counter} sx={operationLogStyle(log.operationName)}>
              <Typography sx={{ marginBottom: '8px' }}>
                {`${dayjs(log.operationDate).format('YYYY年M月D日　HH:mm:ss')}`}
              </Typography>
              <Stack direction='row'>
                <Typography sx={{ ...typography.body16bold, width: '100px' }}>{log.operationName}</Typography>
                {log.noticeTypeCode != null &&
                  <Stack sx={{ marginLeft: '16px' }}>
                    <Stack direction='row' sx={{ marginBottom: '4px', gap: '8px' }}>
                      <NoticeTypeIcon
                        noticeTypeCode={log.noticeTypeCode}
                        sx={{ width: '24px', height: '24px' }}
                      />
                      {noticeTypeLabel(log.noticeTypeCode)}
                    </Stack>
                    <Stack direction='row'>
                      <Typography sx={{ marginRight: '16px' }}>{`${log.noticeSectionName}`}</Typography>
                      <Typography>{`${log.noticeStartStationName}〜${log.noticeEndStationName}`}</Typography>
                    </Stack>
                  </Stack>
                }
              </Stack>
            </Stack>
          ))}
        </DialogContent>
      </Dialog>
    );
  };
};

export default OperationLogDialog;

OperationLogDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  operationLog: PropTypes.array,
};
